<template>
  <div>
    <div :class="{ overlay: toggleNav }" @click="toggleNav = false">
      <div v-show="toggleNav" class="nav-close" @click="toggleNav = false">
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-close.png`)" alt="close button">
      </div>
    </div>
    <div v-if="showHeaderSearch" class="desktop-search" @click="showSearchGame">
      <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-search.png`)" alt=""></i>
    </div>
    <div v-if="banner && !isMobile()" class="chatbox" @click="goHelpCenter">
      <i><img :src="banner.image" alt=""></i>
    </div>
    <header>
      <div class="header-toggler" @click="toggleNav = true">
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-header-toggler.png`)" alt="navbar for mobile devices">
      </div>
      <div class="header-logo" @click="goHome">
        <img :src="$store.state.brand.info.h5_image" alt="logo for mobile devices" height="49px">
      </div>
      <div v-if="showＨeaderNotification" class="header-notification" @click="handleLinkClick('/user/letter')">
        <div class="red-dot" :class="{dis_none:!$store.state.user.unreadLetter }" />
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon_bell.png`)" alt="notification">
      </div>
      <div v-if="showHeaderHome" class="header-search" @click="goHome">
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-home.png`)" alt="home">
      </div>
      <div v-if="showCloseBtn" class="header-search" @click="goHome">
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-close-black.png`)" alt="close">
      </div>
      <div v-if="showHeaderSearch" class="header-search" @click="showSearchGame">
        <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-search.png`)" alt="search game">
      </div>
    </header>
    <div v-if="!$store.getters.token" class="nav-login-topbox">
      <div class="nav-bottom-no-login login-bg ">
        <button class="button-style-3 btn-nav-deposit" @click="goSignup()">
          <span>{{ $t("Bao.register") }}</span>
        </button>
        <button class="button-style-3 btn-nav-deposit" @click="goLogin()">
          <span>{{ $t('Bao.login') }}</span>
        </button>
      </div>
    </div>

    <nav ref="navMenu" :class="{ active: toggleNav }">
      <!-- 左側選單-未登入 -->
      <template v-if="!$store.getters.token">
        <div
          class="nav-header login-bg"
        >
          <div class="nav-no-login">
            <div class="nav-login-logo" @click="goHome">
              <img :src="$store.getters.brand.image" alt="home">
            </div>
            <div class="nav-no-login-button">
              <button class="button-style-1 btn-nav-sign-up " tag="button" @click="goSignup()">
                <span>{{ $t("Bao.register") }}</span>
              </button>
              <button class="button-style-2 btn-nav-sign-in" tag="button" @click="goLogin()">
                <span>{{ $t('Bao.login') }}</span>
              </button>
            </div>
          </div>
        </div>
      </template>
      <!-- 左側選單-已登入 -->
      <template v-if="$store.getters.token">
        <div class="nav-header login-bg">
          <div class="nav-login">
            <div class="nav-login-logo" @click="goHome">
              <img :src="$store.getters.brand.image" alt="home" style="width: 220px;">
            </div>
            <div class="user-info">
              <div class="user-info-name" @click="$router.push('/user')">
                <div class="user-info-text">
                  <span class="h4">{{ $store.getters.name }}</span>
                  <span>{{ $t('Bao.account') }}</span>
                </div>
                <div class="user-info-personal" @click.stop="refreshGold()">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-refresh.png`)" alt="refresh gold">
                </div>
              </div>
              <div class="user-info-level">
                <span class="h5">{{ $t('Bao.level') }}:</span>
                <span class="h5">{{ $store.state.user.vipInfo.currentVipName }}</span>
              </div>
              <div class="user-info-point">
                <span class="h5">{{ $t('Bao.katsu_points') }}</span>
                <span>{{ $store.getters.point | numberFormat }}</span>
              </div>
              <div class="user-info-balance">
                <span>{{ $t('Bao.main_gold') }}</span>
                <span>{{ $store.state.brand.currency }}{{ $store.getters.mainGold | numberFormat }}</span>
              </div>
              <div class="user-info-balance">
                <span>{{ $t('Bao.bonus_gold') }}</span>
                <span>{{ $store.state.brand.currency }}{{ $store.getters.bonusGold | numberFormat }}</span>
              </div>
            </div>
            <div class="nav-login-button">
              <button
                v-show="$store.state.brand.permissionInfo.enable_deposit === 1"
                class="button-style-3 btn-nav-deposit"
                @click="$router.push('/deposit')"
              >
                <span>{{ $t('Bao.deposit') }}</span>
              </button>
              <button
                v-show="$store.state.brand.permissionInfo.enable_withdrawal === 1"
                class="button-style-3 btn-nav-withdrawal"
                @click="$router.push('/withdrawal')"
              >
                <span>{{ $t('Bao.withdrawal') }}</span>
              </button>
            </div>
          </div>
        </div>
      </template>
      <div
        ref="navChamp"
        class="nav-link-list"
      >
        <div class="link-item" @click="handleClick">
          <div class="link-item-name brush-item" :class="{ active: $route.path === '/page/support' }">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/new_guide.png`)" alt="Guidance for newbies">
            </div>
            <div class="link-item-text">
              <span>{{ $t('Bao.support_center') }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="$store.state.user.championEvent.length > 0"
          class="link-item"
          @click="goChampionship"
        >
          <div class="link-item-name brush-item">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-flag.png`)" alt="Flag icon for champion event">
            </div>
            <div class="link-item-text">
              <span>{{ $t('Bao.championship_name') }}</span>
            </div>
          </div>
        </div>
        <!-- 每日活動 -->
        <div
          v-if="$store.getters.brandImageCheckKey('top_left_corner_icon') && isOpenDailyAttend"
          class="link-item"
        >
          <div
            v-for="(item, key) in $store.getters.brandImage.top_left_corner_icon"
            :key="key"
            class="link-item-name brush-item"
            @click="getDailyItem(item)"
          >
            <template v-if="item.link == 'DailyBox'">
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/daily-attend.png`)" alt="Daily attend">
                <span>{{ item.name }}</span>
              </div>
            </template>
            <template v-else>
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/daily-attend.png`)" alt="Daily attend">
              </div>
              <div class="link-item-text">
                <span>{{ item.name }}</span>
              </div>
            </template>
          </div>
        </div>
        <div v-if="$store.getters.token" class="link-item">
          <div
            class="link-item-name brush-item"
            :class="{ active:
              $route.path === '/points/vip-rewards' ||
              $route.path === '/points/coupon' ||
              $route.path === '/points/roulette-bonus'||
              $route.path === '/points/membership-benefits' ||
              $route.path === '/points/free-spin' ||
              $route.path === '/points/overview' }"
            @click="jumptoShop"
          >
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/shop.png`)" alt="vip rewards">
            </div>
            <div class="link-item-text">
              <span>{{ $t("Bao.shop") }}</span>
            </div>
          </div>
        </div>
        <div v-if="$store.state.user.lotteryId" class="link-item">
          <div class="link-item-name brush-item" :class="{ 'active': $store.state.user.wheelOpen }" @click="openWheel">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/fortunewheel.png`)" alt="FortuneWheel for daily spin">
            </div>
            <div class="link-item-text">
              <span>{{ $t("Bao.roulette") }}</span>
            </div>
          </div>
        </div>
        <div class="link-item">
          <div class="link-item-name brush-item" :class="{ active: $route.path === '/vip' } " @click="$router.push('/vip')">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/vip-crown.png`)" alt="vip">
            </div>
            <div class="link-item-text">
              <span>{{ $t("Bao.vip_club") }}</span>
            </div>
          </div>
        </div>
        <div class="link-item">
          <div class="link-item-name brush-item" :class="{ active: $route.path === '/event' } " @click="$router.push('/event')">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/event.png`)" alt="event">
            </div>
            <div class="link-item-text">
              <span>{{ $t("Bao.event") }}</span>
            </div>
          </div>
        </div>
        <div class="link-item" @click="handleLinkClick('/user/friend')">
          <div class="link-item-name brush-item" :class="{ 'active': $route.path === '/user/friend' }">
            <div class="link-item-image">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/friend_promo.png`)" alt="friend promo">
            </div>
            <div class="link-item-text">
              <span> {{ $t("Bao.promos") }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 左側選單-首頁 -->
      <template>
        <div ref="navGameType" class="nav-link-list">
          <div class="link-item" :class="{ active: toggleAllGame }">
            <div class="link-item-name" @click="toggleAllGame = !toggleAllGame">
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon_allgames.png`)" alt="all games">
              </div>
              <div class="link-item-text">
                <span>{{ $t("Bao.all_game") }}<i /></span>
              </div>
            </div>
            <ul class="link-item-dropdown">
              <li
                v-for="(type, key) in $store.getters.gameType"
                :key="'type_' + key"
                class="link-item brush-item"
                :class="{ 'active': type === selectedTab }"
                @click="changeGameType(type)"
              >
                <div class="link-item-image">
                  <img :src="type.image_pc_icon" alt="change game type">
                </div>
                <div class="link-item-text">
                  <span>{{ type.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div ref="navGameCateory" class="nav-link-list">
          <div class="link-item" :class="{ active: toggleHOT }">
            <div class="link-item-name" @click="toggleHOT = !toggleHOT">
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-recommend.png`)" alt="recommend">
              </div>
              <div class="link-item-text">
                <span>{{ $t("Bao.recommend_game") }}<i /></span>
              </div>
            </div>
            <ul class="link-item-dropdown">
              <li
                v-for="(item, key) in $store.getters.gameCategory"
                :key="'game_' + key"
                class="link-item brush-item"
                :class="{ 'active': item === selectedTab }"
                @click="changeGameCategory(item)"
              >
                <div class="link-item-image">
                  <img :src="item.image" alt="change game category">
                </div>
                <div class="link-item-text">
                  <span>{{ item.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <!--共用功能區塊-->
      <template>
        <div class="nav-link-list">
          <div ref="navPersonal" class="link-item" :class="{ active: toogleMyAccout }">
            <div class="link-item-name" @click="toogleMyAccout = !toogleMyAccout">
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/my-account.png`)" alt="account">
              </div>
              <div class="link-item-text">
                <span>{{ $t("Bao.personal") }}<i /></span>
              </div>
            </div>
            <ul class="link-item-dropdown">
              <li
                class="brush-item"
                :class="{ active: $route.path === '/user' }"
                @click="handleLinkClick('/user')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.profile") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active: $route.path === '/user/bet' }"
                @click="handleLinkClick('/user/bet')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.my_game_bet") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active:
                  $route.path === '/user/transaction' ||
                  $route.path === '/user/bonus' ||
                  $route.path === '/user/commission' ||
                  $route.path === '/user/deposit-record' ||
                  $route.path === '/user/withdrawal-record' }"
                @click="handleLinkClick('/user/transaction')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.transaction-index") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active:
                  $route.path === '/user/bank' || $route.path === '/user/bank/create' }"
                @click="handleLinkClick('/user/bank')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.add_bank_card") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active: $route.path === '/user/letter' }"
                @click="handleLinkClick('/user/letter')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.announcement_letter") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active: $route.path === '/user/news' }"
                @click="handleLinkClick('/user/news')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.news") }}</span>
                </div>
              </li>
              <li
                class="brush-item"
                :class="{ active: $route.path.startsWith('/user/event/me') }"
                @click="handleLinkClick('/user/event/me')"
              >
                <div class="link-item-text">
                  <span>{{ $t("Bao.bonus_info") }}</span>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="$store.getters.token" class="link-item">
            <div
              class="link-item-name brush-item"
              :class="{ active: $route.path === '/user/edit' || $route.path === '/user/KYC'} "
              @click="$router.push('/user/edit')"
            >
              <div class="link-item-image">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/verify.png`)" alt="user verify">
              </div>
              <div class="link-item-text">
                <span>{{ $t("Bao.verify_account") }}</span>
              </div>
            </div>
          </div>
          <div class="link-item">
            <div
              class="language-item"
              :class="{ active: toogleSelectLanguage }"
              @click="toogleSelectLanguage = !toogleSelectLanguage"
            >
              <div class="language-item-current">
                <i><img :src="getLanguageIcon(selectedLanguage)" alt="change language"></i>
                <span>{{ selectedLanguage }}</span>
                <i class="language-arrow" />
              </div>
              <ul>
                <li
                  v-for="(item, key) in this.$store.state.brand.info.full_language"
                  :key="key"
                  @click="changeLanguage(key)"
                >
                  <i><img :src="getLanguageIcon(item)" :alt="item"></i>
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
          <quick-bar />
        </div>
      </template>
      <div v-if="$store.state.game.showOffGameBets" class="nav-link-list nav-jackopt-list">
        <h4>{{ $t('Bao.latest_big_win') }}</h4>
        <div
          v-for="(item, key) in visibleItems"
          ref="carousel"
          :key="key"
          class="nav-jackpot"
          :class="{'nav-jackopt-color': shouldApplyClass(key)}"
          @click="handleLaunchGame(item)"
        >
          <i><img width="30" :src="getImageSource(item.type)" alt=""></i>
          <div class="nav-jackpot-text">
            <span class="member_nickname">{{ item.member_nickname }}
              <span class="bet_time">{{ item.created_at | timeFormat }}</span>
              <span class="bet_result">{{ item.bet_result }} {{ $store.getters.brand.currency }}</span>
            </span>
            <span>{{ item.game_name }}</span>
          </div>
        </div>
      </div>
      <div class="nav-link-list">
        <h4>{{ $t('Bao.social_media') }}</h4>
        <div class="social-web-frame">
          <div v-for="(media, key) in followMedia" :key="key" class="social-icons-frame">
            <a class="social-icons" :href="media.link" :target="'_' + media.open_type"><img :src="media.image" alt=""></a>
          </div>
        </div>
      </div>
      <!--登出按鈕-->
      <button v-show="$store.getters.token" class="button-style-4 nav-logout-button" @click="logout">
        <span>{{ $t('Bao.logout') }}</span>
      </button>
    </nav>
    <main class="bg-repeat" :class="isModalOpen">
      <router-view />
      <!-- 頁腳 -->
      <footer>
        <div class="footer-width">
          <!-- 頁腳-文字連結 -->
          <div class="footer-top">
            <div class="footer-link-list">
              <span>{{ $t('Bao.KatsuWIN') }}</span>
              <a @click.prevent="$router.push('/page/agent')">
                {{ $t('Bao.affiliate') }}
              </a>
              <a @click.prevent="$router.push('/page/support')">
                {{ $t('Bao.support_center_footer') }}
              </a>
              <a @click.prevent="$router.push('/page/sup-faq')">
                FAQ
              </a>
              <a @click.prevent="$router.push('/page/cooperation')">
                {{ $t('Bao.become_agent') }}
              </a>
              <a @click="goProxy">
                {{ $t('Bao.affiliates') }}
              </a>
            </div>
            <div v-if="$store.getters.gameType" class="footer-link-list">
              <template v-if="showBetting">
                <span>{{ $t('Bao.betting') }}</span>
                <a v-for="(type, key) in bettingSlice" :key="'betting'+key" @click="changeGameType(type)">{{ type.name }}</a>
              </template>
              <template v-if="showGaming">
                <a v-for="(type, key) in gamingSlice" :key="'gaming'+key" @click="changeGameType(type)">{{ type.name }}</a>
              </template>
            </div>

            <div class="footer-link-list">
              <span>{{ $t('Bao.useful_link') }}</span>
              <a @click.prevent="$router.push('/page/terms')">
                {{ $t('Bao.terms_conditions') }}
              </a>
              <a @click.prevent="$router.push('/page/rule')">
                {{ $t('Bao.game_rule') }}
              </a>
              <a @click.prevent="$router.push('/page/privacy')">
                {{ $t('Bao.agent_help_type_4') }}
              </a>
              <a @click.prevent="$router.push('/page/cookie-policy')">
                {{ $t('Bao.cookie_policy') }}
              </a>
              <a @click.prevent="$router.push('/page/sup-responsible-gaming')">
                {{ $t('Bao.res_gaming') }}
              </a>
            </div>
            <div v-if="$store.state.brand.brandImage.follow_media !== undefined" class="footer-link-list icon-link">
              <div class="footer-link-list icon-link">
                <span>{{ $t('Bao.follow_us') }}</span>
                <ul>
                  <li
                    v-for="(item, key) in followMedia"
                    :key="key"
                  >
                    <a :href="item.link" :target="newWindows(item)">
                      <img :src="item.image" alt="">
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- sns 手機版 -->
          <div class="footer-link-list-mb icon-link">
            <span>{{ $t('Bao.follow_us') }}</span>
            <ul>
              <li
                v-for="(item, key) in followMedia"
                :key="key"
              >
                <a :href="item.link" :target="newWindows(item)">
                  <img :src="item.image" alt="">
                </a>
              </li>
            </ul>
          </div>

          <!-- 客服資訊 -->
          <div class="footer-help">
            <div class="footer-title">
              {{ $t('Bao.footer_help') }}
            </div>

            <div class="footer-help-list">
              <div @click="goHelpCenter">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/comments-question.svg`)" alt="METHOD FOR USER TO CONTACT">
                <p>{{ $t('Bao.chat_access') }}</p>
                <span><p>{{ $t('Bao.chat_start') }}</p></span>
                <p>{{ $t('Bao.chat_time') }}</p>
              </div>
              <div>
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/email.svg`)" alt="METHOD FOR USER TO CONTACT">
                <p>{{ $t('Bao.email_access') }}</p>
                <span><a href="mailto:support@katsuwin.ai"><p>support@katsuwin.ai</p></a></span>
                <p>10:00〜23:00</p>
              </div>
            </div>
          </div>

          <!-- 銀行 -->
          <div class="footer-bank">
            <div class="footer-title">
              {{ $t('Bao.safe_payment') }}
            </div>

            <ul>
              <li v-for="(safePayment, key) in sortedImages" :key="key">
                <img :src="safePayment.image" :alt="safePayment.name">
              </li>
            </ul>
          </div>

          <!-- 遊戲供應商 -->
          <div class="footer-providers">
            <div class="footer-title">
              {{ $t('Bao.event_daily_attend_game_provider_setting') }}
            </div>

            <template v-if="main_image.sponsor_footer !== undefined">
              <ul class="footer_sponsor">
                <li v-for="(item, key) in main_image.sponsor_footer" :key="key">
                  <img class="mw-100" :src="item.image" height="40" :alt="item.name">
                </li>
              </ul>
            </template>
          </div>

          <!-- 牌照 -->
          <div class="footer-licensed">
            <div class="footer-title">
              {{ $t('Bao.license') }}
            </div>
            <div
              id="anj-9b71cd6e-8774-4a76-a655-2ade6138fae4"
              data-anj-seal-id="9b71cd6e-8774-4a76-a655-2ade6138fae4"
              data-anj-image-size="48"
              data-anj-image-type="basic-small"
            />
            <div
              id="anj-5c72c516-517d-4335-bac9-33b0f916b5c3"
              data-anj-seal-id="5c72c516-517d-4335-bac9-33b0f916b5c3"
              data-anj-image-size="48"
              data-anj-image-type="basic-small"
            />
            <p>
              {{ $t('Bao.license_footer') }}
            </p>
          </div>

          <!-- k站簡介 -->
          <div class="footer-intro">
            <div class="footer-title">
              {{ $t('Bao.platform_intro') }}
            </div>
            <p>
              {{ $t('Bao.platform_intro_desc1') }}
            </p>
            <p v-if="showText('Bao.platform_intro_desc2')">
              {{ $t('Bao.platform_intro_desc2') }}
            </p>
            <p v-if="showText('Bao.platform_intro_desc3')">
              {{ $t('Bao.platform_intro_desc3') }}
            </p>
            <p v-if="showText('Bao.platform_intro_desc4')">
              {{ $t('Bao.platform_intro_desc4') }}
            </p>
          </div>

          <!-- 證照 -->
          <div class="footer-responsible">
            <div class="footer-title">
              {{ $t('Bao.footer_responsible') }}
            </div>

            <ul>
              <li>
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/footer_gaming1.png`)" alt="IMAGE OF RESPONSIE GAMING">
              </li>
              <li>
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/footer_gaming2.png`)" alt="IMAGE OF RESPONSIE GAMING">
              </li>
              <li>
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/footer_gaming3.png`)" alt="IMAGE OF RESPONSIE GAMING">
              </li>
              <li>
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/footer_gaming4.png`)" alt="IMAGE OF RESPONSIE GAMING">
              </li>
            </ul>
          </div>

          <!-- 頁腳-版權 -->
          <div class="footer-Kcopyright">
            <p>Copyright © 2022 Katsuwin. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
      <!-- 手機版-底部 -->
      <div class="nav-bottom" :class="{ hidden: !showNav }">
        <!-- 手機版-底部-選單 -->
        <div class="nav-bottom-menu">
          <ul>
            <router-link to="/" tag="li" :class="{ active: isActiveTab('home') }" @click.native="setActiveTab('home')">
              <i><img :src="getIconSource('home')" alt="home"></i>
              <span>{{ $t("Bao.home") }}</span>
            </router-link>
            <router-link to="/vip" tag="li" :class="{ active: isActiveTab('vip') }" @click.native="setActiveTab('vip')">
              <i><img :src="getIconSource('vip')" alt="vip"></i>
              <span>{{ $t('Bao.vip_club') }}</span>
            </router-link>
            <router-link to="/event" tag="li" :class="{ active: isActiveTab('offers') }" @click.native="setActiveTab('offers')">
              <i><img :src="getIconSource('offers')" alt="event"></i>
              <span>{{ $t('Bao.event_nav') }}</span>
            </router-link>
            <router-link to="/deposit" tag="li" :class="{ active: isActiveTab('deposit') }" @click.native="setActiveTab('deposit')">
              <i><img :src="getIconSource('deposit')" alt="deposit"></i>
              <span>{{ $t('Bao.deposit') }}</span>
            </router-link>
            <router-link to="/user" tag="li" :class="{ active: isActiveTab('my') }" @click.native="setActiveTab('my')">
              <i><img :src="getIconSource('my')" alt="user"></i>
              <span>{{ $t('Bao.my') }}</span>
            </router-link>
          </ul>
        </div>
      </div>
    </main>
    <register-modal />
    <login-modal />
    <forget-modal />
    <success-register />
    <Toast />
    <wheel-vue />
  </div>
</template>

<script>
import { getTypeMenuInfo, getCategory } from '@/api/game'
import { gameStart } from '@/utils/games'
import { getEvent, getBetRankList } from '@/api/event'
import { getBrandGameProviderSidebar, getBanner } from '@/api/brand'
import { page } from '@/api/common'
import quickBar from '@/components/quickBar'
import loginModal from '@/components/modal/loginModal'
import Toast from '@/components/modal/toast'
import forgetModal from '@/components/modal/forgetModal'
import registerModal from '@/components/modal/registerModal'
import Cookies from 'js-cookie'
import { showNotice, showAd } from '@/utils/tool'
import { logout as localLogout } from '@/utils/user'
import { newWindows, refreshGold, isCrossDay, detectMob } from '@/utils/tool'
import SuccessRegister from '@/components/modal/successRegister.vue'
import wheelVue from '../../components/modal/wheel.vue'

export default {
  name: 'Main',
  components: {
    quickBar,
    loginModal,
    registerModal,
    forgetModal,
    Toast,
    SuccessRegister,
    wheelVue
  },
  data() {
    return {
      toggleNav: false,
      toogleSelectLanguage: false,
      toggleAllGame: true,
      toggleHOT: false,
      toogleMyAccout: false,
      selectedLanguage: '',
      events: [],
      isShowFooterLink: false,
      isPersonalMenu: true,
      isOtherMenu: true,
      main_image: null,
      sponsor_footer: null,
      footerIntro: null,
      selectedItem: {},
      activeTab: '',
      banner: '',
      selectedTab: null,
      showNav: true,
      lastScrollTop: 0,
      isHideImage: true,
      isClamped: true,
      isExpanded: false,
      isFirstRender: true,
      isOpenDailyAttend: false,
      currentIndex: 0,
      itemsPerPage: 10,
      intervalId: null
    }
  },
  computed: {
    isModalOpen() {
      return this.$store.state.user.isLoginActive ||
             this.$store.state.user.isRegisterActive ||
             this.$store.state.user.isForgetActive ||
             this.$store.state.brand.showSearch ||
             this.$store.state.brand.showProvider ||
             this.toggleNav
    },
    bettingSlice() {
      return this.$store.getters.gameType.slice(0, 4)
    },
    gamingSlice() {
      return this.$store.getters.gameType.slice(4, 8)
    },
    showBetting() {
      return this.bettingSlice.some(type => type.name !== '')
    },
    showGaming() {
      return this.gamingSlice.some(type => type.name !== '')
    },
    sortedImages() {
      const images = [...this.$store.state.brand.brandImage.safe_payment]
      return images.sort((a, b) => a.sort - b.sort)
    },
    showCloseBtn() {
      return this.$store.state.brand.showSearch ||
      this.$store.state.brand.showProvider
    },
    showHeaderHome() {
      return !this.$store.getters.token &&
      this.$store.state.user.isLoginActive ||
      this.$store.state.user.isRegisterActive ||
      this.$store.state.user.isForgetActive ||
      this.$store.state.user.isRegisterSimpleActive
    },
    showHeaderSearch() {
      if (this.$route.path === '/' && !this.$store.state.brand.showSearch && !this.$store.state.brand.showProvider) {
        return this.$store.state.user.currentGameType === null &&
        this.$store.state.user.currentGameProvider === null &&
        !this.$store.state.user.isGameFilterActive &&
        !this.$store.state.user.isLoginActive &&
        !this.$store.state.user.isRegisterActive &&
        !this.$store.state.user.isForgetActive &&
        !this.$store.state.user.isRegisterSimpleActive
      }
      return false
    },
    showＨeaderNotification() {
      if (this.$route.path === '/' && !this.$store.state.brand.showSearch && !this.$store.state.brand.showProvider && this.$store.getters.token) {
        return this.$store.state.user.currentGameType === null &&
        this.$store.state.user.currentGameProvider === null &&
        !this.$store.state.user.isGameFilterActive
      }
      return false
    },
    followMedia() {
      return this.$store.state.brand.brandImage.follow_media
    },
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    visibleItems() {
      const bets = this.$store.state.game.showOffGameBets || []
      const startIndex = this.currentIndex
      const endIndex = startIndex + this.itemsPerPage
      return bets.slice(startIndex, endIndex)
    }
  },
  watch: {
    gameUrlFromStore(newVal, oldVal) {
      if (newVal !== oldVal) {
        const headerElement = document.querySelector('header')
        if (newVal) {
          headerElement.style.display = 'none'
          this.disableScrolling()
        } else {
          this.enableScrolling()
          headerElement.style.display = window.innerWidth < 992 ? 'block' : 'none'
        }
      }
    },
    '$route'(to, from) {
      this.checkIsHomeLeftMenu()
      this.setToggleNavAndCommit()

      // mobile bottom nav
      const path = this.$route.path
      if (path !== '/') {
        this.selectedTab = null
        this.$store.commit('SET_GAME_URL', null)
        this.$store.state.app.tempGameUrl = ''
      }
      if (path === '/') {
        this.setActiveTab('home')
      } else if (path.startsWith('/vip')) {
        this.setActiveTab('vip')
      } else if (path.startsWith('/event')) {
        this.setActiveTab('offers')
      } else if (path.startsWith('/deposit')) {
        this.setActiveTab('deposit')
      } else if (path.startsWith('/user')) {
        this.setActiveTab('my')
      } else {
        this.setActiveTab('')
      }
    },
    toggleNav(newVal) {
      this.toggleBodyStyle(newVal)
    },
    '$store.state.user.currentGameType'(to) {
      if (this.$route.path === '/' && this.$store.state.user.currentGameCategory === null) {
        this.selectedTab = to
        this.scrollToNavElement('navGameType')
        this.refreshProvider(to.game_type)
      }
    },
    '$store.state.user.currentGameCategory'(to) {
      const navMenu = this.$refs.navMenu
      if (to === null) {
        navMenu.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      } else if (this.isFirstRender) {
        this.isFirstRender = false
      } else if (this.$route.path === '/' && this.$store.state.user.currentGameType === null) {
        this.selectedTab = to
        this.toggleHOT = true
        this.$nextTick(() => {
          this.scrollToNavElement('navGameCateory')
        })
      }
    },
    isModalOpen(newValue) {
      if (newValue) {
        this.disableScrolling()
      } else {
        this.enableScrolling()
      }
    }
  },
  created() {
    this.checkIsHomeLeftMenu()
    // 初始化
    this.$store.commit('SET_FORGET_OPEN', this.$store.state.user.isValidateFail)
    this.$store.commit('SET_GAME_TYPE', null)
    this.$store.commit('SET_CURRENT_GAME_TYPE', null)
    this.$store.commit('SET_SHOW_GAME_FILTER', false)
    this.$store.commit('SET_REGISTER_OPEN', false)
    this.$store.commit('SET_LOGIN_OPEN', false)
    this.$store.commit('SET_CHECKOUT_COUNTER_OPEN', false)
    this.$store.commit('SET_CHECKOUT_COUNTER_BCPAY_OPEN', false)
    this.$store.commit('SET_RESET_PASSWORD_OPEN', false)
    this.$store.commit('SET_VAILTADA_FAIL', false)
    this.$store.commit('SET_SHOW_PROVIDER', false)
    this.$store.commit('SET_SHOW_RESEARCH', false)

    getTypeMenuInfo().then((response) => {
      this.$store.commit('SET_GAME_TYPE', response.data.data)
      let allProvider = []
      for (const item of response.data.data) {
        allProvider = [
          ...allProvider,
          ...item.providers
        ]
      }

      // Sort the allProvider array by item.providers.sort
      allProvider.sort((a, b) => a.sort - b.sort)
      this.$store.commit('SET_GAME_PROVIDER', allProvider)
    })

    this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
    getCategory().then((response) => {
      this.$store.commit('SET_GAME_CATEGORY', response.data.data)
    })
    this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
    getBrandGameProviderSidebar().then((response) => {
      response.data.data.sort(function(a, b) {
        return a.sort - b.sort
      })
      this.$store.commit('SET_GAME_SIDE_BAR_PROVIDER', response.data.data)
    })

    getBanner().then((response) => {
      this.banner = response.data.data[0]
    })

    let currentLangKey = ''
    if (this.$route.query.language) {
      currentLangKey = this.$route.query.language
    } else if (Cookies.get('language')) {
      currentLangKey = Cookies.get('language')
    } else {
      currentLangKey = 'zh'
    }
    this.$store.commit('SET_LANGUAGE', currentLangKey)
    for (const i in this.$store.state.brand.info.full_language) {
      if (i === currentLangKey) {
        this.selectedLanguage = this.$store.state.brand.info.full_language[i]
      }
    }

    // main image
    if (this.$store.state.brand.brandImage !== null) {
      this.main_image = this.$store.state.brand.brandImage
    }

    // News
    getEvent({
      page: 1,
      page_size: 50
    }).then((response) => {
      this.events = response.data.data.list
      this.dispatchV4Events()
      this.callDailyPopup()
    })

    this.fetchFooterIntro()

    // mobile bottom nav
    const path = this.$route.path
    if (path === '/') {
      this.setActiveTab('home')
    } else if (path.startsWith('/vip')) {
      this.setActiveTab('vip')
    } else if (path.startsWith('/event')) {
      this.setActiveTab('offers')
    } else if (path.startsWith('/deposit')) {
      this.setActiveTab('deposit')
    } else if (path.startsWith('/user')) {
      this.setActiveTab('my')
    }

    getBetRankList().then(response => {
      const eventArr = []
      response.data.event.forEach(item => {
        if (item.status === 1 && item.is_sys_disabled === 0) {
          eventArr.push(item)
        }
      })
      this.$store.commit('SET_CHAMPIONSHIP_EVENT', eventArr)
    })
  },
  mounted() {
    this.showSealBasedOnDomain()
    // 添加事件监听器以响应窗口大小变化
    window.addEventListener('resize', this.checkForClamping)

    this.toggleBodyStyle(this.toggleNav)
    // DO NOT REMOVE BELOW CODE, IT'S FOR LICENSE USED
    // eslint-disable-next-line
    // apg_162a63e8_2cd9_4099_95dd_08cf009a0263.init()
    // eslint-disable-next-line
    anj_9b71cd6e_8774_4a76_a655_2ade6138fae4.init()
    // eslint-disable-next-line
    anj_5c72c516_517d_4335_bac9_33b0f916b5c3.init() 

    window.addEventListener('scroll', this.handleScroll)
    this.checkIsHomeLeftMenu()
    this.startCarousel()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkForClamping)
    // Reset the body style when the component is destroyed
    this.toggleBodyStyle(false)

    window.removeEventListener('scroll', this.handleScroll)
    this.enableScrolling()
    this.stopCarousel()
  },
  methods: {
    showText(key) {
      return this.$t(key) && this.$t(key).trim().length > 0
    },
    showSealBasedOnDomain() {
      const currentDomain = window.location.hostname
      const seal1 = document.getElementById('anj-9b71cd6e-8774-4a76-a655-2ade6138fae4')
      const seal2 = document.getElementById('anj-5c72c516-517d-4335-bac9-33b0f916b5c3')

      if (currentDomain === 'www.katsuwin.io') {
        seal1.style.display = 'inline-block'
        seal2.style.display = 'none'
      } else if (currentDomain === 'www.katsuwin.ai') {
        seal1.style.display = 'none'
        seal2.style.display = 'inline-block'
      } else {
        seal1.style.display = 'inline-block'
        seal2.style.display = 'none'
      }
    },
    shouldApplyClass(index) {
      return index % 2 !== 0
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        const showOffGameBets = this.$store.state.game.showOffGameBets

        if (showOffGameBets && this.itemsPerPage > 0) {
          this.currentIndex = this.currentIndex + 1
        }
        if (showOffGameBets && this.currentIndex - 1 === showOffGameBets.length - this.itemsPerPage) {
          this.currentIndex = 0
        }
      }, 3000)
    },
    stopCarousel() {
      clearInterval(this.intervalId)
    },
    refreshProvider(gameType) {
      let allProvider = []
      const providerDic = {}
      getTypeMenuInfo().then((response) => {
        allProvider = response.data.data
        for (const i in allProvider) {
          const index = allProvider[i].game_type
          providerDic[index] = allProvider[i].providers
        }
        providerDic[gameType].sort((a, b) => a.sort - b.sort)
        this.$store.commit('SET_GAME_PROVIDER', providerDic[gameType])
      })
    },
    handleClick() {
      if (this.$route.path === '/page/support') {
        window.location.reload()
      } else {
        this.$router.push('/page/support')
      }
    },
    isMobile() {
      return detectMob()
    },
    fetchFooterIntro() {
      const timestamp = Date.now()
      page({ type: 'footer_intro', timestamp: timestamp }).then(response => {
        this.footerIntro = response.data.data.content
      })
    },
    checkForClamping() {
      const textWrapper = this.$refs.textWrapper
      if (textWrapper) {
        this.isClamped = textWrapper.scrollHeight > textWrapper.clientHeight
      }
    },
    toggleText() {
      this.isClamped = !this.isClamped
      this.isExpanded = !this.isExpanded
    },
    openWheel() {
      this.toggleNav = false
      this.$store.commit('SET_WHEEL_OPEN', true)
    },
    dispatchV4Events() {
      let foundLottery = false
      this.events.forEach(event => {
        if (event.type === 'signup_v4') {
          this.$store.commit('ADD_V4_ID', event.id)
        }
        if (event.type === 'daily_lottery') {
          foundLottery = true
          this.$store.commit('ADD_LOTTERY_ID', event.id)
        }
        if (event.type === 'daily_attend') {
          this.isOpenDailyAttend = true
        }
      })
      if (!foundLottery) {
        this.$store.commit('ADD_LOTTERY_ID', null)
      }
    },
    callDailyPopup() {
      this.$nextTick(() => {
        // if commercial cross day, show it
        if (this.$store.state.user.lotteryId && this.$store.getters.permissionInfo.enable_pop_announcement) {
          const currentTimeStamp = Math.floor(Date.now() / 1000)
          const storedTimeStamp = localStorage.getItem('lastCommercialTimeStamp')
          if (storedTimeStamp) {
            if (isCrossDay(currentTimeStamp, parseInt(storedTimeStamp, 10))) {
              localStorage.setItem('lastCommercialTimeStamp', currentTimeStamp.toString())
              setTimeout(() => {
                this.$store.commit('SET_WHEEL_OPEN', true)
              }, 8000)
            } else {
              this.$store.commit('SET_WHEEL_OPEN', false)
            }
          } else {
            localStorage.setItem('lastCommercialTimeStamp', currentTimeStamp.toString())
            setTimeout(() => {
              this.$store.commit('SET_WHEEL_OPEN', true)
            }, 8000)
          }
        } else if (!this.$store.state.user.lotteryId) {
          showAd(this.$store.getters.permissionInfo.pop_announcement_image, this.$store.state.brand.permissionInfo.pop_announcement_url, this.$store.state.brand.permissionInfo.pop_announcement_url_open_type)
        }
      })
    },
    toggleBodyStyle(open) {
      if (open) {
        document.body.style.overflow = 'hidden'
        document.body.style.overscrollBehavior = 'none'
      } else {
        document.body.style.overflow = ''
        document.body.style.overscrollBehavior = ''
      }
    },
    changeGameType(item) {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
      this.selectedTab = item
      this.setToggleNavAndCommit()
      this.isShowFooterLink = false
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_SHOW_GAME_FILTER', true)
      this.$store.commit('SET_CURRENT_GAME_TYPE', item)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
    },
    changeGameCategory(item) {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
      this.selectedTab = item
      this.setToggleNavAndCommit()
      const filterValue = item ? 'others' : 'favorites'
      this.$store.commit('SET_CURRENT_GAME_TYPE', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_SHOW_GAME_FILTER', false)
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      this.$store.commit('SET_ACTIVE_FILTER', filterValue)
      this.$nextTick(() => {
        const wrapper = this.$el.querySelector('.list-wrapper')
        const activeItem = this.$el.querySelector('li.active')
        if (wrapper && activeItem) {
          const offsetLeft = activeItem.offsetLeft
          const halfWrapperWidth = wrapper.clientWidth / 2
          const halfItemWidth = activeItem.clientWidth / 2
          wrapper.scrollLeft = offsetLeft - halfWrapperWidth + halfItemWidth
        }
      })
    },
    changeLanguage(key) {
      for (const i in this.$store.state.brand.info.full_language) {
        if (i === key) {
          this.selectedLanguage = this.$store.state.brand.info.full_language[i]
        }
      }
      this.setToggleNavAndCommit()
      var url = new URL(document.location.href)
      url.searchParams.set('language', key)
      document.location.href = url
    },
    goHome() {
      if (this.$store.state.user.isRegisterActive) {
        this.$store.commit('SET_REGISTER_OPEN', false)
      } else if (this.$store.state.user.isLoginActive) {
        this.$store.commit('SET_LOGIN_OPEN', false)
      } else if (this.$store.state.user.isRegisterSimpleActive) {
        this.$store.commit('SET_SIMPLE_REGISTER_OPEN', false)
      } else {
        this.$store.commit('SET_FORGET_OPEN', false)
      }

      if (this.$route.path !== '/') {
        this.$router.push('/')
      } else if (this.$store.state.brand.showSearch) {
        this.$store.commit('SET_SHOW_RESEARCH', false)
        return
      } else if (this.$store.state.brand.showProvider) {
        this.$store.commit('SET_SHOW_PROVIDER', false)
        return
      }

      this.setToggleNavAndCommit()
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', this.$store.state.game.gameCategory[0])
      this.$store.commit('SET_SHOW_GAME_FILTER', false)
      if (this.$store.state.user.currentGameType) {
        this.$store.commit('SET_CURRENT_GAME_TYPE', null)
      }
    },
    goSignup() {
      this.setToggleNavAndCommit()
      this.$store.commit('SET_REGISTER_OPEN', true)
    },
    goLogin() {
      this.setToggleNavAndCommit()
      this.$store.commit('SET_LOGIN_OPEN', true)
    },
    logout() {
      this.setToggleNavAndCommit()
      localLogout()
    },
    checkIsHomeLeftMenu() {
      const personalMap = ['Personal', 'UserBet', 'Transaction', 'Bank', 'Message', 'Bonus', 'EditName', 'KYC', 'DepositRecord', 'WithdrawalRecord', 'BankCard', 'UserBonus', 'UserCommission', 'DepositRecord', 'WithdrawalRecord', 'News']
      if (personalMap.indexOf(this.$route.name) > -1) this.isPersonalMenu = false
      else this.isPersonalMenu = true

      const otherMap = ['Coupon', 'rouletteBonus', 'membershipBenefits', 'vipRewards', 'VipIndex', 'eventList', 'UserFriend', 'Support', 'freeSpin', 'Overview']
      if (otherMap.indexOf(this.$route.name) > -1) this.isOtherMenu = false
      else this.isOtherMenu = true

      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.isPersonalMenu) {
            this.toogleMyAccout = true
            this.scrollToNavElement('navPersonal')
          } else if (!this.isOtherMenu) {
            this.scrollToNavElement('navChamp')
          } else {
            const navMenu = this.$refs.navMenu
            navMenu.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            })
          }
        }, 300)
      })
    },
    newWindows(obj) {
      return newWindows(obj)
    },
    setActiveTab(tab) {
      this.activeTab = tab
      if (this.$store.state.user.currentGameType && tab !== 'home') {
        this.$store.commit('SET_CURRENT_GAME_TYPE', null)
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', this.$store.state.game.gameCategory[0])
        this.$store.commit('SET_SHOW_GAME_FILTER', false)
      }
      if (tab === 'deposit' && this.$store.state.brand.permissionInfo.enable_deposit !== 1) {
        showNotice(this.$t('Bao.deposit_maintain'))
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      }
    },
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    getIconSource(tab) {
      const isActive = this.isActiveTab(tab)
      const activeSuffix = isActive ? '-active' : ''
      const theme = this.$store.getters.currentTheme
      if (theme === 'theme_gold') {
        return require(`@/assets/${theme}/images/nav-bottom-${tab}${activeSuffix}.webp`)
      } else {
        return require(`@/assets/${theme}/images/nav-bottom-${tab}${activeSuffix}.png`)
      }
    },
    getLanguageIcon(language) {
      const theme = this.$store.getters.currentTheme
      if (language === '日本語') {
        return require(`@/assets/${theme}/images/jp_logo.png`)
      } else if (language === '繁') {
        return require(`@/assets/${theme}/images/ch_logo.png`)
      } else {
        return require(`@/assets/${theme}/images/en_logo.png`)
      }
    },
    refreshGold() {
      refreshGold()
    },
    setToggleNavAndCommit() {
      this.toggleNav = false
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.$store.commit('SET_SIMPLE_REGISTER_OPEN', false)
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_FORGET_OPEN', false)
    },
    setLiveChatWidget(username, email) {
      LiveChatWidget.call('set_customer_name', username)
      LiveChatWidget.call('set_customer_email', email)
      LiveChatWidget.call('maximize')
    },
    goHelpCenter() {
      const isGuest = !this.$store.getters.token
      let formattedLink = this.banner.link

      if (isGuest) {
        if (this.banner.open_type === '_iframe') {
          this.setLiveChatWidget('guest', 'guest@katsuwin.io')
        } else {
          const url = new URL(formattedLink)
          formattedLink = `${url.origin}${url.pathname}`
          window.open(formattedLink, this.banner.open_type)
        }
      } else {
        const { username, email, is_pass_KYC, first_deposit_amount, second_deposit_amount, third_deposit_amount, birthday, vip_last_updated_at, last_withdrawal_amount, last_withdrawal_updated_at } = this.$store.state.user.memberInfo
        const kycStatusMap = {
          0: 'KYC_NONE',
          1: 'KYC_PASS',
          2: 'KYC_PROGRESS'
        }
        const isPassKYC = kycStatusMap[is_pass_KYC]
        const { currentVipName } = this.$store.state.user.vipInfo

        if (this.banner.open_type === '_iframe') {
          LiveChatWidget.call('set_session_variables', {
            kyc: isPassKYC,
            dep1: first_deposit_amount,
            dep2: second_deposit_amount,
            dep3: third_deposit_amount,
            vip: currentVipName,
            birthday: birthday,
            vip_last_updated_at: vip_last_updated_at === 0 ? 0 : this.$options.filters.dateFormat(vip_last_updated_at),
            last_withdrawal_amount: last_withdrawal_amount,
            last_withdrawal_updated_at: last_withdrawal_updated_at === 0 ? 0 : this.$options.filters.dateFormat(last_withdrawal_updated_at)
          })
          this.setLiveChatWidget(username, email)
        } else {
          const encodedUsername = encodeURIComponent(username)
          const encodedEmail = encodeURIComponent(email)

          formattedLink = formattedLink
            .replace('{NAME}', encodedUsername)
            .replace('{EMAIL}', encodedEmail)
            .replace('&amp;', '&')
            .replace('{K}', isPassKYC)
            .replace('{D}', `${first_deposit_amount},${second_deposit_amount},${third_deposit_amount}`)
          window.open(formattedLink, this.banner.open_type)
        }
      }
    },
    goChampionship() {
      const routeData = this.$router.resolve({ path: '/championship' })
      window.open(routeData.href, '_blank')
    },
    goProxy() {
      const routeData = this.$router.resolve({ path: '/affiliate' })
      window.open(routeData.href, '_blank')
    },
    showSearchGame() {
      this.$store.commit('SET_SHOW_RESEARCH', true)
    },
    handleLinkClick(path) {
      this.$router.push(path)
      if (!this.$store.getters.token) {
        this.toggleNav = false
      }
    },
    jumptoShop() {
      if (this.isMobile()) {
        this.$router.push('/points/overview')
      } else {
        this.$router.push('/points/membership-benefits')
      }
    },
    handleLaunchGame(item) {
      const gameData = {}
      gameData.id = item.game_id
      gameData.game_open_type = item.game_provider.game_open_type
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
      gameStart('game', gameData)
      this.toggleNav = false
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop
      if (scrollTop > this.lastScrollTop) {
        // Scrolling down
        this.showNav = false
      } else {
        // Scrolling up
        this.showNav = true
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    },
    scrollToNavElement(refName) {
      this.$nextTick(() => {
        const navMenu = this.$refs.navMenu

        const navElement = this.$refs[refName]
        if (navMenu && navElement) {
          const navElementPosition = navElement.offsetTop - 80
          navMenu.scrollTo({ top: navElementPosition, behavior: 'smooth' })
        }
      })
    },
    disableScrolling() {
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
      document.body.style.overflow = ''
    },
    getDailyItem(item) {
      window.open(item.link, item.open_type)
      this.$store.commit('SET_DAILY_ITEM', item)
    },
    getImageSource(type) {
      switch (type) {
        case 1:
          return require(`@/assets/${this.$store.getters.currentTheme}/images/slots.png`)
        case 2:
          return require(`@/assets/${this.$store.getters.currentTheme}/images/live.png`)
        case 10:
          return require(`@/assets/${this.$store.getters.currentTheme}/images/skill.png`)
        case 13:
          return require(`@/assets/${this.$store.getters.currentTheme}/images/pachislot.png`)
        default:
          return require(`@/assets/${this.$store.getters.currentTheme}/images/slots.png`)
      }
    }
  }
}
</script>
<style>
.lincense-wrap {
  margin: 0 auto;
  width: 60px;
  padding-bottom: 20px;
}

.license_footer {
  color: #797979;
}

.nav-bottom {
  transition: transform 0.3s ease-in-out;
}

.nav-bottom.hidden {
  transform: translateY(100%);
}

.tc-download {
    margin-left: -10px;
  }

.text-wrapper {
  line-height: 1.8em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pre-wrap {
  white-space: pre-wrap;
}

</style>

